import React, { Component } from 'react';
import { Alert, Modal } from "react-bootstrap";
import {FaRegTimesCircle} from 'react-icons/fa';

const ErrorAlert = (props) => {

    const { alertBody, ...modalProps } = props;

    return (
        <Modal {...modalProps} animation={true} id="erorAlert" size="md" centered>
            <Modal.Body>
                <Alert>
                    <Alert.Heading className="mb-0 fs-20">
                        <FaRegTimesCircle className='mb-2 pb-4 cancelIcon' style={{fontSize: '80px'}} />
                        <p className='mb-2'>Error !!</p>
                    </Alert.Heading>
                    <p className="d-flex justify-content-center mt-4">{`${alertBody}`}</p>
                </Alert>
            </Modal.Body>
        </Modal>
    )
}

export default ErrorAlert;